<template>
  <b-row>
    <b-col sm="4">Share with users:</b-col>
    <b-col sm="8">
      <v-select class='select-no-caret' v-model='sharedUsers' multiple :options="users" />
    </b-col>
  </b-row>
</template>

<script>
import vSelect from 'vue-select'

export default {
  name: 'ShareSelect',
  components: {
    vSelect
  },

  data () {
    return {
      sharedUsers: [],
      users: []
    }
  },

  mounted () {
    this.loadUsers()
  },

  methods: {
    loadUsers () {
      this.$http.get('/users', {user_id: this.$store.getters.currentUser.id})
        .then(function(response){
          this.users = response.data.map(function(user){
            return user.email
          }.bind(this))
          this.users = this.users.filter((email) => { return email != null})
          this.users = this.users.filter(email => email !== this.$store.getters.currentUser.email)
          this.users = this.users.sort()
        }.bind(this))
    }
  }

}
</script>
